import Link from 'next/link'
import { Nav } from 'react-bootstrap'
import { Designed } from 'web_core/types'
import { isBlank } from 'web_core/utils'

type Props = {
  link: string
  variant?: 'tabs' | 'pills'
  active: 'articles' | 'books' | 'users'
  keyword: string | null | undefined
}

export const SearchNavSelector = ({
  link,
  active,
  variant = 'tabs',
  keyword,
  ...wrapperProps
}: Designed<Props>) => {
  const suffix =
    !isBlank(keyword) && keyword !== '' ? `?keyword=${keyword}` : ''
  return (
    <Nav variant={variant} {...wrapperProps}>
      <Nav.Item>
        <Link href={link.replace('[target]', 'articles') + suffix} passHref>
          <Nav.Link active={active === 'articles'}>記事</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href={link.replace('[target]', 'books') + suffix} passHref>
          <Nav.Link active={active === 'books'}>本</Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item>
        <Link href={link.replace('[target]', 'users') + suffix} passHref>
          <Nav.Link active={active === 'users'}>ユーザ</Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  )
}
